<div class="flex flex-col gap-1">
  @switch (granularity()) {
    @case ('YEAR')
    @case ('MONTH') {
      <div>{{ date() | date: 'cccc dd.MM.yyyy' }}</div>
    }
    @case ('WEEK')
    @case ('DAY') {
      <div>{{ date() | date: 'cccc dd.MM.yyyy HH:mm' }}</div>
    }
  }
  @let p = displayPrice();
  @if (p !== undefined) {
    <div>
      {{ 'cockpit.analysis.hpfc.detail.tooltipPrice' | transloco }}:
      <span class="font-semibold"> {{ p | germanNumber }} {{ unitKey() | transloco }} </span>
    </div>
  }
  @if (isPrognosis()) {
    @let lower = displayLower();
    @let upper = displayUpper();
    @if (lower !== undefined && upper !== undefined) {
      <div>
        {{ 'cockpit.analysis.hpfc.detail.tooltipRange' | transloco }}: {{ lower | germanNumber }} –
        {{ upper | germanNumber }}
        {{ unitKey() | transloco }}
      </div>
    }
  }
  @let cp = displayComparisonPrice();
  @if (cp !== undefined) {
    <div>
      @if (comparisonYear()) {
        {{ comparisonYear() }}:
      } @else {
        {{ 'cockpit.analysis.hpfc.detail.tooltipComparison' | transloco }}:
      }
      <span class="font-semibold"> {{ cp | germanNumber }} {{ unitKey() | transloco }} </span>
    </div>
  }
</div>
